import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles({
  rootContent: {
    flex: '1 1 auto',
  },
  inline: {
    display: 'inline',
    marginLeft: 0,
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: 10,
    flex: '1 1 auto',
  },
  title: {
    fontSize: 16,
    fontFamily: 'PoppinsSemiBold',
    lineHeight: '21px',
  },
  description: {
    fontSize: 12,
    lineHeight: '16px',
  },
  icon: {
    width: 16,
    height: 16,
    borderRadius: 8,
    marginRight: 16,
    marginTop: 4,
    display: 'inline-block',
  },
});

const useTooltipStyles = makeStyles(theme =>
  createStyles({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: theme.palette.text.primary,
      border: `1px solid #222222`,
      width: 400,
      borderRadius: 0,
      opacity: '1 !important',
      padding: '30px 18px 20px',
      [theme.breakpoints.down('xs')]: {
        marginTop: 16,
      },
    },
    popper: {
      zIndex: 1301,
    },
    arrow: {
      '&::before': {
        border: `1px solid #222222`,
        backgroundColor: '#FFFFFF',
        boxSizing: 'border-box',
      },
    },
  }),
);

function EvidenceTooltip(props) {
  const classes = useStyles();
  const tooltipClasses = useTooltipStyles();
  const [toolTipData] = useSiteCopySelector(['tooltip']);
  let toolTipValues;

  if (!_isEmpty(toolTipData)) {
    toolTipValues = _get(toolTipData, 'pageCopy', {});
  }
  const { children } = props;
  const contentData = [
    {
      name: _get(toolTipValues, ['labels', 'Good Evidence']),
      description: _get(toolTipValues, 'Good Evidence', ''),
      iconColor: '#20D1AC',
    },
    {
      name: _get(toolTipValues, ['labels', 'Some Evidence']),
      description: _get(toolTipValues, 'Some Evidence', ''),
      iconColor: '#0BA6C2',
    },
    {
      name: _get(toolTipValues, ['labels', 'Good Idea']),
      description: _get(toolTipValues, 'Insufficient Evidence', ''),
      iconColor: '#136369',
    },
  ];

  const content = (
    <Grid container direction="column" className={classes.rootContent}>
      {contentData.map(({ name, iconColor, description }) => (
        <Grid item xs={12} className={classes.content} key={name}>
          <div>
            <span
              className={classes.icon}
              style={{ backgroundColor: iconColor }}
            />
          </div>
          <div>
            <Typography className={classes.title}>{name}</Typography>
            <Typography className={classes.description}>
              {description}
            </Typography>
          </div>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <div className={classes.inline}>
      <Tooltip
        classes={tooltipClasses}
        placement="right"
        arrow
        TransitionComponent={({ children: transitionChildren }) =>
          transitionChildren
        }
        title={content}
        PopperProps={{
          modifiers: { flip: { enabled: false } },
        }}
      >
        {children}
      </Tooltip>
    </div>
  );
}

EvidenceTooltip.propTypes = {
  children: PropTypes.node,
};

export default EvidenceTooltip;
